//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

export const COMPANY = 'Rocketgraph';
// In terms of use and external copyrights this shows.
export const LEGAL_COMPANY = 'Trovares';
export const PRODUCT_NAME = 'Rocketgraph Mission Control';
export const PRODUCT_SERVER_NAME = 'xGT';
export const PRODUCT_ABBREVIATION = 'MC';
